import { Inject, Injectable } from '@angular/core';
import { ErrorMessage } from '../Models/ErrorMessage';
import { DEFAULT_ERRORS } from '../default-errors';
import { CUSTOM_ERROR_MESSAGES } from '../Tokens/tokens';
export class ErrorMessageService {
private defaultErrors = DEFAULT_ERRORS;
/**
 * @param {?=} customErrorMessages
 */
constructor(
public customErrorMessages: ErrorMessage[] = []
  ) {}
/**
 * @return {?}
 */
get errorMessages() {
    return [...this.customErrorMessages, ...this.defaultErrors];
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Array, decorators: [{ type: Inject, args: [CUSTOM_ERROR_MESSAGES, ] }, ]},
];
}

function ErrorMessageService_tsickle_Closure_declarations() {
/** @type {?} */
ErrorMessageService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ErrorMessageService.ctorParameters;
/** @type {?} */
ErrorMessageService.prototype.defaultErrors;
/** @type {?} */
ErrorMessageService.prototype.customErrorMessages;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ~/ng-bootstrap-form-validation/ng-bootstrap-form-validation/src/lib/Services/error-message.service.ts